import React, { Component } from "react";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { WIDGETS } from "../../../../constants/common";

const useStyles = makeStyles({
  label: {
    display: "block"
  },
  root: {
    marginLeft: "5px",
    marginRight: "5px"
  }
});

export default function DisaggFooter(props) {
  const classes = useStyles();
  return (
    <div className="disagg-feedback">
      <div className="feedback-head"><span data-widget-name={WIDGETS.FAQ} data-text-color="color_2">{props.translations.data["DISAGG101.FOOTER_TITLE"]}</span></div>
      <div className="like-dislike-container">
        <div className="fbody">
          <Button
            className="thumbs-up"
            classes={{ label: classes.label, root: classes.root }}
            onClick={props.thumbsUpClick}
            data-widget-name={WIDGETS.FAQ} data-border-color="color_3"
          >
            <span className="feedback-icon bidgely-icon-thumbs-up" data-widget-name={WIDGETS.FAQ} data-icon-color="color_1"></span>
            <div className="feedback-text" data-widget-name={WIDGETS.FAQ} data-text-color="color_3">{props.translations.data["DISAGG101.FOOTER_TEXT_YES"]}</div>
          </Button>
          <Button
            className="thumbs-down"
            classes={{ label: classes.label, root: classes.root }}
            onClick={props.thumbsDownClick}
            data-widget-name={WIDGETS.FAQ} data-border-color="color_3"
          >
            <span className="feedback-icon bidgely-icon-thumbs-down" data-widget-name={WIDGETS.FAQ} data-icon-color="color_1"></span>
            <div className="feedback-text" data-widget-name={WIDGETS.FAQ} data-text-color="color_3">{props.translations.data["DISAGG101.FOOTER_TEXT_NO"]}</div>
          </Button>
        </div>
      </div>
    </div>
  );
}
